import { render } from "./Messages.vue?vue&type=template&id=f9aa76be&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=ts"
export * from "./Messages.vue?vue&type=script&lang=ts"

import "./Messages.vue?vue&type=style&index=0&id=f9aa76be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f9aa76be"

export default script